// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2wzaA","subheader":"ReorderModal_subheader__Db-ma","listWrap":"ReorderModal_listWrap__1xTBb"};